export default __webpack_public_path__ + "static/media/2p_side.514b6a31.png";